import React, { useEffect } from 'react';
import { translate } from '../Services/translation';

const MapAndAddress = ({ title, address, link, apiKey }) => {
  const handleChangeAdress = () => {
    window.location.href = link;
  };

  let Norkart = Norkart || {};
  Norkart.solkart = {};

  useEffect(() => {
    // eslint-disable-next-line no-undef
    Norkart.solkart.map = window.map = new WebatlasMap('mapcontainer', {
      customer: {
        apiKey,
      },
      // eslint-disable-next-line no-undef
      defaultTileLayer: L.TileLayer.WA.Type.HYBRID,
    });

    // eslint-disable-next-line no-undef
    L.tileLayer
      .wms('http://waapi.webatlas.no/wms-takhelning/', {
        layers: 'takhelning:takhelning',
        format: 'image/png',
        transparent: true,
        maxZoom: 20,
        apitoken: apiKey,
        attribution: 'Norkart © ',
      })
      .addTo(Norkart.solkart.map);

    if (address.aust && address.nord) {
      Norkart.solkart.map.setView([address.aust, address.nord], 20);
    }
  }, []);

  return (
    <>
      <section className="roof-map-section">
        <div className="roof-map-section-map">
          <div id="mapcontainer" className="roof-map-section-map__container" />
        </div>
        <div className="roof-map-section-content">
          <span className="roof-map-section-content__address">
            {(address.gatenavn && address.gatenavn) +
              (address.husNr && ' ' + address.husNr) +
              (address.husBokstav && address.husBokstav) +
              (address.postNummer &&
                address.postSted &&
                ' ' + address.postNummer) +
              (address.postSted && ' ' + address.postSted)}
          </span>
          <h1 className="roof-map-section-content__title">{title}</h1>
          <button
            className="roof-map-section-content__link"
            onClick={() => handleChangeAdress()}
          >
            {translate('solcellepanel.general.changeaddress')}
          </button>
        </div>
      </section>
    </>
  );
};

export default MapAndAddress;
